import { render, staticRenderFns } from "./ModuleLi.vue?vue&type=template&id=3c3bcc41&scoped=true"
import script from "./ModuleLi.vue?vue&type=script&lang=js"
export * from "./ModuleLi.vue?vue&type=script&lang=js"
import style0 from "./ModuleLi.vue?vue&type=style&index=0&id=3c3bcc41&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3bcc41",
  null
  
)

export default component.exports